import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const SITE = useContent();
  return (
  <footer className="bg-stone-900 text-stone-300">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-display text-3xl text-white">
            {SITE.name}<span className="text-rose-500">.</span>
          </p>
          <p className="mt-3 text-sm text-stone-400 max-w-xs">{SITE.role} · {SITE.tagline}</p>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="text-stone-500 uppercase tracking-widest text-xs mb-2">Navegação</span>
          <a href="#sobre" className="hover:text-white transition-colors">Sobre</a>
          <a href="#servicos" className="hover:text-white transition-colors">Serviços</a>
          <a href="#abordagem" className="hover:text-white transition-colors">Abordagem</a>
          <Link to="/marcacao" className="hover:text-white transition-colors">Marcar consulta</Link>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="text-stone-500 uppercase tracking-widest text-xs mb-2">Contacto</span>
          <a href={`mailto:${SITE.email}`} className="hover:text-white transition-colors">{SITE.email}</a>
          <a href={`tel:${(SITE.phone || '').replace(/\s/g, '')}`} className="hover:text-white transition-colors">{SITE.phone}</a>
          <span className="text-xs text-stone-500">Chamada para a rede móvel nacional</span>
          <a href={SITE.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
            {SITE.instagram}
          </a>
          <span>{SITE.location}</span>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="flex flex-wrap gap-x-6 gap-y-3 text-xs text-stone-400">
          <Link to="/politica-de-privacidade" className="hover:text-white transition-colors" data-testid="footer-privacy-link">
            Política de Privacidade
          </Link>
          <Link to="/politica-de-cookies" className="hover:text-white transition-colors" data-testid="footer-cookies-link">
            Política de Cookies
          </Link>
          <a
            href="https://www.livroreclamacoes.pt/inicio"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 hover:text-white transition-colors"
            data-testid="footer-complaints-link"
          >
            Livro de Reclamações <ExternalLink className="w-3 h-3" />
          </a>
          <Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">
            Área reservada
          </Link>
        </div>
        <span className="text-xs text-stone-500">
          © {new Date().getFullYear()} {SITE.fullName}. Todos os direitos reservados.
        </span>
      </div>
    </div>
  </footer>
  );
};
